import classNames from 'classnames';
import { type FeatureCardPromotionalProps } from './FeatureCardPromotional.types';
import FeatureCardMain from '../FeatureCardMain';
import FeatureCardImage from '../FeatureCardImage';

const FeatureCardPromotional: React.FC<FeatureCardPromotionalProps> = ({
  showTitle,
  subTitle,
  title,
  titleImage,
  content,
  linkText,
  linkExternal,
  linkInternal,
  imageLink,
  isImageSideSwapped,
  internalLinkFirstCategory,
  date,
}) => (
  <div
    className={classNames(
      'feature-card feature-card--promotional',
      isImageSideSwapped ? 'feature-card--swapped' : '',
    )}
  >
    <FeatureCardImage imageStyle="" imageLink={imageLink} />
    <FeatureCardMain
      showTitle={showTitle}
      subTitle={subTitle}
      title={title}
      content={content}
      linkText={linkText}
      linkExternal={linkExternal}
      linkInternal={linkInternal}
      titleImage={titleImage}
      internalLinkFirstCategory={internalLinkFirstCategory}
      date={date}
      largeHeading
      smallHeading={false}
    />
  </div>
);

export default FeatureCardPromotional;
